const testimonials = [
  {
    name: "Danielle Freitas",
    photo: "https://storage.readdy-site.link/project_files/1e35e2d4-1ac9-4631-be62-9bfa95bf1155/fedffe2e-635a-4a2d-b4ff-f5ab20e867a1_241e415a-dbb2-4ae8-985d-fbd913d0bf96.jpg?v=dae3be4beeac4c2974251f0f51af89a2",
    comment: "Loja maravilhosa! Muitas opções de roupas femininas elegantes, com tecidos de ótima qualidade e peças bem diferenciadas. Atendimento super atencioso. Super confiável 🙏🏽😘",
    stars: 5,
  },
  {
    name: "Marília Barros",
    photo: "https://storage.readdy-site.link/project_files/1e35e2d4-1ac9-4631-be62-9bfa95bf1155/494b44d0-10c1-4311-b01b-805d5ebf9ae9_d49c0c4f-a4bd-4737-a97b-f0b8135d56ad.jpg?v=9f6cc7df95ef78ba3c8d7d57a732968a",
    comment: "Loja maravilhosa, atendimento personalizado. Super recomendo!!",
    stars: 5,
  },
  {
    name: "Larissa Modesto",
    photo: "https://storage.readdy-site.link/project_files/1e35e2d4-1ac9-4631-be62-9bfa95bf1155/a18e9e19-7d7c-4f4d-b57e-3919ea67e8c5_6d89ec9d-e6c7-4a18-ac4f-651ed88f9de0.jpg?v=cfded768f8c5b4cfa39bfc0453e89f4c",
    comment: "Melhor loja pra mim, compro à tempos com ela. Peças incríveis, de ótima qualidade, bonitas e o caimento delas no corpo é sensacional. Minha loja preferida de longos anos.",
    stars: 5,
  },
];

export default function TestimonialsSection() {
  return (
    <section className="py-16 px-4 md:px-8 bg-[#FAF8F5]">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex items-center gap-4 mb-12">
          <div className="flex-1 h-px bg-black/15" />
          <h2 className="text-[14px] tracking-[0.3em] font-semibold text-black uppercase px-2">
            O que dizem nossas clientes
          </h2>
          <div className="flex-1 h-px bg-black/15" />
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {testimonials.map((t) => (
            <div
              key={t.name}
              className="bg-white p-8 flex flex-col items-center text-center"
            >
              {/* Stars */}
              <div className="flex items-center gap-1 mb-5">
                {Array.from({ length: t.stars }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#C9A96E] text-sm" />
                ))}
              </div>

              {/* Comment */}
              <p className="text-[13px] text-black/65 leading-relaxed mb-7 italic">
                &ldquo;{t.comment}&rdquo;
              </p>

              {/* Divider */}
              <div className="w-8 h-px bg-black/15 mb-6" />

              {/* Avatar + name */}
              <div className="flex flex-col items-center gap-3">
                <div className="w-14 h-14 rounded-full overflow-hidden flex-shrink-0 border-2 border-black/8">
                  <img
                    src={t.photo}
                    alt={t.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <p className="text-[12px] font-semibold text-black tracking-[0.08em] uppercase">
                  {t.name}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
